import { memo, useCallback } from 'react';
import { useAsync } from 'react-use';
import cn from 'classnames';
import { getWithUrl } from 'src/utils/http';
import { Container, Element, Icon, RouterLink } from 'src/components';

import { API_URL } from '@zmedia/bm-soccer-ui/constants/env';
import { IMatch } from '@zmedia/bm-soccer-ui/interface';
import MatchItem from './MatchItem';
import { twMerge } from 'tailwind-merge';
import { IContent } from 'src/interface';

interface ISoccerEvent {
    items: IMatch[];
    name: string;
    url: string;
}

const SOCCER_API = API_URL + '/app/match/get/widget-content-detail';

const EventSoccer = ({ content }: { content: IContent }) => {
    const matchState = useAsync(() =>
        getWithUrl(
            SOCCER_API,
            {
                tournamentId: content.tournamentId,
            },
            [],
        ),
    );

    const data: ISoccerEvent = matchState.value?.data || {};
    const { items = [], name, url } = data;

    const renderItem = useCallback(() => {
        return items.map((item: IMatch) => (
            <RouterLink
                key={item.id}
                to={item.url}
                className={twMerge(
                    'w-[46%]',
                    'shrink-0',
                    'mx-[4px]',
                    'rounded-[12px]',
                    'bg-[rgba(0,0,0,0.05)]',
                    cn({
                        'w-1/2 shrink': items.length <= 2,
                    }),
                )}
            >
                <MatchItem {...item} />
            </RouterLink>
        ));
    }, [items]);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Element
                className={cn(
                    'event-soccer',
                    'mt-[20px]',
                    'pt-[24px]',
                    'border-t border-solid border-[#F0F0F0]',
                )}
            >
                <Element className={cn('mb-[12px]')}>
                    <RouterLink
                        to={url}
                        className="leading-[1] flex items-center"
                    >
                        <Element
                            className={cn(
                                'text-[#000] text-[13px] font-[900] uppercase',
                            )}
                        >
                            {name}
                        </Element>
                        <Icon
                            className="text-[16px] ml-[12px] text-[#1e1e1e]"
                            icon="new-arrLong-solid"
                        />
                    </RouterLink>
                </Element>

                <Element
                    className={cn(
                        'max-md:mx-[-20px]',
                        'max-md:px-[16px]',
                        'xs:max-md:mx-[-10vw]',
                        'xs:max-md:px-[calc(10vw-4px)]',
                        'md:mx-[-20px]',
                        'flex',
                        'overflow-auto [&::-webkit-scrollbar]:hidden',
                    )}
                >
                    {renderItem()}
                </Element>
            </Element>
        </>
    );
};
export default memo(EventSoccer);
